
import request from '@/utils/request';
// 用户列配置

// 用户列配置查询
export function queryUserColumnSettingApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/columnSetting/queryUserColumnSetting',
    method: 'post',
    data
  });
}

// 用户列配置修改
export function insertUserColumnSettingApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/columnSetting/insertUserColumnSetting',
    method: 'post',
    data
  });
}

// 用户列配置恢复系统默认设置
export function resetUserColumnSettingApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/columnSetting/resetUserColumnSetting',
    method: 'post',
    data
  });
}